import * as React from 'react';
import {colorError} from 'src/variables'

interface Props {
  onClick: () => void;
}

export const HiddenMessage: React.SFC<Props> = ({ onClick }) => (
  <div style={{minHeight: "50px", border: `2px solid ${colorError}`, width: '100%', color: colorError}}>
    <span style={{lineHeight: "50px"}}>
      Dieses Event ist ausgeblendet. <a onClick={onClick} style={{textDecoration: 'underline'}}>Einblenden</a>
    </span>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/Event/EventDetail/HiddenMessage/HiddenMessage.tsx